export default {
      id: "support-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#support",
      toString: function () {
        return this.url;
      }
    }